import { render, staticRenderFns } from "./SModalTeamRequestConfirmation.vue?vue&type=template&id=5175fa7e&scoped=true"
import script from "./sModalTeamRequestConfirmation.ts?vue&type=script&lang=ts&external"
export * from "./sModalTeamRequestConfirmation.ts?vue&type=script&lang=ts&external"
import style0 from "./SModalTeamRequestConfirmation.vue?vue&type=style&index=0&id=5175fa7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5175fa7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5175fa7e')) {
      api.createRecord('5175fa7e', component.options)
    } else {
      api.reload('5175fa7e', component.options)
    }
    module.hot.accept("./SModalTeamRequestConfirmation.vue?vue&type=template&id=5175fa7e&scoped=true", function () {
      api.rerender('5175fa7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-modal-team-request-confirmation/SModalTeamRequestConfirmation.vue"
export default component.exports